import { createContext } from 'react';
import type { ThemeMode } from '../types/theme';

export interface ThemeContextType {
  theme: ThemeMode;
  resolvedTheme: 'light' | 'dark';
  loading: boolean;
  setTheme: (newTheme: ThemeMode) => void;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(
  undefined,
);
